import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';
import '../../styles/ScrollToTopButton.scss';

function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  // Check if the button should be visible
  useEffect(() => {
    const checkVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', checkVisibility);

    return () => {
      window.removeEventListener('scroll', checkVisibility);
    };
  }, []);

  // Scroll to the top of the page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!isVisible) {
    return null;
  }

  return (
    <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
      <FaArrowUp aria-hidden="true" />
    </button>
  );
}

export default ScrollToTopButton;
